/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DetachSpecificSpecialPlaceFromDevicesCommand
 */
export interface DetachSpecificSpecialPlaceFromDevicesCommand {
    /**
     * 
     * @type {string}
     * @memberof DetachSpecificSpecialPlaceFromDevicesCommand
     */
    specialPlaceId: string;
}

export function DetachSpecificSpecialPlaceFromDevicesCommandFromJSON(json: any): DetachSpecificSpecialPlaceFromDevicesCommand {
    return DetachSpecificSpecialPlaceFromDevicesCommandFromJSONTyped(json, false);
}

export function DetachSpecificSpecialPlaceFromDevicesCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): DetachSpecificSpecialPlaceFromDevicesCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specialPlaceId': json['specialPlaceId'],
    };
}

export function DetachSpecificSpecialPlaceFromDevicesCommandToJSON(value?: DetachSpecificSpecialPlaceFromDevicesCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specialPlaceId': value.specialPlaceId,
    };
}


